<div class="body">
  <storever-loading-data *ngIf="false else dataForm"></storever-loading-data>
  <ng-template #dataForm>
    <form [formGroup]="dataConfig?.form" class="formHeight">
      <ul class="list-group">
        <div class="width-100">
          <storever-element-group
            class="lineSpace"
            [icon]="'fal fa-hdd'"
            [title]="'PLAYER_CONFIGURATION_TITLE'"
            [config]="dataConfig?.groupConfigs?.groupConfigs[0]?.config"
            [form]="dataConfig?.form"
            [isEdit]="true"
            [paramEdit]="{text: 'GENERIC_EDIT', icon: 'fal fa-comment-plus', type: 'order', case: 'order'}"
            (save)="save(['PlayerConfigurationEditComponent', 'playerConfig'])"
            (undo)="undo(['playerConfig'])"
            [stylingClass]="'dynamic-form'">
          </storever-element-group>
        </div>
      </ul>
    </form>
  </ng-template>
</div>
<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  <pre style="flex:1;word-break:break-word;line-height:2;">{{dataConfig.groupConfigs.groupConfigs[0]?.config|json}}</pre>
<!--  <pre style="flex: 1 1 0px">dataConfig.form{{dataConfig.form.value|json}}</pre>-->
</div>
